<template>
    <div class="m-stepper-object-choose">
        <div class="content-border-area">
            <v-layout v-if="!isOnboarding">
                <v-flex xs12 class="text-xs-right pa-0 ">
                    <e-button-close class="m-dialog__close mt-0" @click="closeDialog(false)"/>
                </v-flex>
            </v-layout>
            <v-layout row wrap :class="{'mt-3': isOnboarding}">
                <v-flex xs12 class="text-xs-center">
                    <e-typography-heading-3>
                        {{$t('modules.dialogs.m-dialog-risk-assessment-create.title')}}
                    </e-typography-heading-3>
                </v-flex>
                <v-flex xs12 class="mt-4 text-xs-center">
                    <e-typography-body-small>
                        {{$t('modules.dialogs.m-dialog-risk-assessment-create.text')}}
                    </e-typography-body-small>
                </v-flex>
                <v-flex xs12>
                    <m-form-risk-assessment class="pa-0 m-dialog-risk-assessment__form" ref="form"/>
                </v-flex>
            </v-layout>
            <v-layout v-if="!isOnboarding">
                <v-flex class="text-xs-center">
                    <e-button-primary @click="createAssessment" :loading="$wait.waiting(keys.riskAssessments.create)">
                        {{$t('modules.dialogs.m-dialog-risk-assessment-create.buttons.submit')}}
                    </e-button-primary>
                </v-flex>
            </v-layout>
        </div>
    </div>
</template>

<script>
    import MDialog from "@components/modules/dialogs/m-dialog";
    import {mapActions, mapGetters} from 'vuex';
    import vuexKeys from "@mixins/includes/_vuexKeys";
    import MFormRiskAssessment from "@modules/forms/concrete/risk-assessment/m-form-risk-assessment";
    import notifications from "@mixins/includes/_notifications";

    export default {
        name: "m-stepper-object-choose",
        inheritAttrs: false,
        components: {MFormRiskAssessment, MDialog},
        mixins: [vuexKeys, notifications],
        props: {
            isOnboarding: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            ...mapGetters({
                isOpened: 'dialogs/isOpened',
                getPromises: 'dialogs/getPromises'
            }),

            isModalOpened() {
                return this.isOpened(this.type);
            },
            type() {
                return 'riskAssessmentCreate';
            }
        },
        methods: {
            async createAssessment() {
                try {
                    const assessmentId = await this.$refs.form.submit();
                    if (assessmentId) {
                        this.closeDialog(assessmentId)
                    }
                } catch (e) {
                    this.notify.processUnhandledError(e)
                }
            },
            async chooseOnboardingObject() {
                try {
                    const objectId = await this.$refs.form.getObject();
                    if (objectId) {
                        this.$emit('setObjectId', objectId)
                    }
                } catch (e) {
                    this.notify.processUnhandledError(e)
                }
            },
        }
    }
</script>

<style lang="scss">
    .m-stepper-object-choose {
        padding: 0 .2rem 2rem;
    }
    .fullscreen {
        .m-stepper-object-choose {
            padding: 0;
        }
    }
</style>